import { Component, ViewContainerRef} from '@angular/core';
import { ShippingCost } from '../../models/shippment/shipping-cost.model';
import { ShippingCostService } from '../../services/shippment/shipping-cost.service';
import { ShippmentService } from '../../services/shippment/shippment-setting';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Shippment } from '../../models/shippment/shippment-model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-add-shipping-cost',
    templateUrl: './add-shipping-cost.component.html',
    styleUrls: ['./add-shipping-cost.component.css']
})
/** add-shipping-cost component*/
export class AddShippingCostComponent {
  shippingCost = new ShippingCost();
  shippmentMethods: Shippment[];
  cityList: any;
  // For Cost List
  shippingCostList: ShippingCost[];

  //Filter items from grid
  filteredItems: any[];
  DublicateFilteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public btnName: string;
  public IsFormLoaded: boolean = false;

  //search Parameter
  public cityFromID: string;
  public cityToID: string;
  public searchKeyword: string;
  public shippingMethodID: string = "";
  public customShippingMethod: string;
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** add-shipping-cost ctor */
  constructor(private readonly shippingCostService: ShippingCostService,
    private readonly toastr: ToastsManager,
    private readonly shippmentService: ShippmentService,
    private readonly utilitiesService: UtilitiesService,
    vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.rolePermissionService.GetRolePermissions("shippmentcost").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.toastr.setRootViewContainerRef(vcr);
          this.GetCityList();
          this.GetShippmentMethods();
          this.GetShippingCostList();
          this.GetRowsPerPageList();
          this.IntializeValues();
          this.IsFormLoaded = true;
          this.cityFromID = "";
          this.cityToID = "";
          this.customShippingMethod = "";
            this.searchKeyword = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  GetCityList() {
    this.shippingCostService.GetCityList().subscribe(data => {
      this.cityList = data;
    });
  }
  GetShippmentMethods() {
    this.shippmentService.GetActiveShippingMethods().subscribe(data => {
      this.shippmentMethods = data;
    });
  }
  //For cost List
  GetShippingCostList() {
    this.shippingCostService.GetShippingCosts().subscribe(data => {
      this.shippingCostList = data;
      //this.filteredItems = data;
      this.OnFilterChange();
    });
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  OnFilterChange() {
    this.filteredItems = this.shippingCostList;

    if (this.cityFromID!="") {
      this.filteredItems = this.filteredItems.filter(s => s.cityFromID == this.cityFromID);
    }
    if (this.cityToID != "") {
      this.filteredItems = this.filteredItems.filter(s => s.cityToID == this.cityToID);
    }
    if (this.shippingMethodID != "") {
      this.filteredItems = this.filteredItems.filter(s => s.shippingMethodID == parseInt(this.shippingMethodID));
    }
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }

  }
  IntializeValues() {
    //this.shippingCost.shippingMethodID = 0;
    this.customShippingMethod = "";
    this.shippingCost.cityFromID = "";
    this.shippingCost.cityToID = "";
    this.shippingCost.cost = 0;
    this.shippingCost.freeLimit = 0;
    this.shippingCost.weight = 0;
    this.shippingCost.height = 0;
    this.shippingCost.width = 0;
    this.shippingCost.length = 0;
    this.shippingCost.id = "";
    this.btnName = "<i class='fa fa-save'></i> Save";
  }
  clearshippingCost() {
    if (this.shippingCost.cost == 0) {
      this.shippingCost.cost = null;
    }
  }
  clearshippingfreeLimit() {
    if (this.shippingCost.freeLimit == 0) {
      this.shippingCost.freeLimit = null;
    }
  }
  clearshippingWeight() {
    if (this.shippingCost.weight == 0) {
      this.shippingCost.weight = null;
    }
  }
  clearshippingHeight() {
    if (this.shippingCost.height == 0) {
      this.shippingCost.height = null;
    }
  }
  clearshippingLength() {
    if (this.shippingCost.length == 0) {
      this.shippingCost.length = null;
    }
  }
  clearshippingWidth() {
    if (this.shippingCost.width == 0) {
      this.shippingCost.width = null;
    }
  }
  keyPress(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
  // End cost List
  //Edit Functionality
  EditCost(shippingCostId: string) {
    this.IsFormLoaded = false;
    this.shippingCostService.GetShippingCostById(shippingCostId).subscribe(data => {
      this.shippingCost = data;
      this.customShippingMethod =this.shippingCost.shippingMethodID.toString();
      this.btnName = "<i class='fa fa-refresh'></i>  Update";
      this.IsFormLoaded = true;
    });
    try {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }
  //delete Functionality
  DeleteShippingCost(id) {
    var ans = confirm("Are you sure to delete this sshipping cost?");
    if (ans) {
      this.shippingCostService.DeleteShippingCost(id).subscribe(result => {
        this.toastr.success('Shipping Cost deleted successfully.', 'Success');
        this.IntializeValues();
        this.GetShippingCostList();
      });
     
    }
  
  }
  ChangeButtonName() {
    this.btnName = "<i class='fa fa-save'></i>  Save";
    this.shippingCost.id = "";
  }
  onSubmit() {
    
    if (this.shippingCost.height == null) {
      this.shippingCost.height = 0;
    }
    if (this.shippingCost.width == null) {
      this.shippingCost.width = 0;
    }
    if (this.shippingCost.length == null) {
      this.shippingCost.length = 0;
    }
    this.shippingCost.shippingMethodID = parseInt(this.customShippingMethod);
    this.DublicateFilteredItems = this.shippingCostList.filter(s => s.id != this.shippingCost.id);
    if (this.DublicateFilteredItems.findIndex(s => s.shippingMethodID == this.shippingCost.shippingMethodID) >= 0) {
      if (this.DublicateFilteredItems.findIndex(s => s.cityFromID == this.shippingCost.cityFromID) >= 0 && this.DublicateFilteredItems.findIndex(s => s.cityToID == this.shippingCost.cityToID) >= 0 && this.DublicateFilteredItems.findIndex(s => s.freeLimit == this.shippingCost.freeLimit) >= 0 && this.DublicateFilteredItems.findIndex(s => s.weight == this.shippingCost.weight) >= 0) {
        this.toastr.error('Shipping Cost already exist with same Free limit and Weight ', 'Error');
      } else if (this.DublicateFilteredItems.findIndex(s => s.cityFromID == this.shippingCost.cityFromID) >= 0 && this.DublicateFilteredItems.findIndex(s => s.cityToID == this.shippingCost.cityToID) >= 0 && this.DublicateFilteredItems.findIndex(s => s.height == this.shippingCost.height) >= 0 && this.DublicateFilteredItems.findIndex(s => s.width == this.shippingCost.width) >= 0 && this.DublicateFilteredItems.findIndex(s => s.length == this.shippingCost.length) >= 0)
      {
        this.toastr.error('Shipping Cost already exist with same Dimensions ', 'Error');
      } else {
        //this.toastr.success('Not in list.', 'success');
        
        this.shippingCostService.AddShippingCost(this.shippingCost).subscribe(result => {
          if (this.shippingCost.id != null && this.shippingCost.id != "") {
            this.toastr.success('Shipping Cost updated successfully.', 'Success');
          } else {
            this.toastr.success('Shipping Cost saved successfully.', 'Success');
          }
          this.GetShippingCostList();
          let btnReset: HTMLElement = document.getElementById('btnReset') as HTMLElement;
          btnReset.click();
          // Intialize with new object
         // this.IntializeValues();
        });
      }
    } else {
      //this.toastr.success('Not in list.', 'success');
      this.shippingCostService.AddShippingCost(this.shippingCost).subscribe(result => {
        if (this.shippingCost.id != null && this.shippingCost.id != "") {
          this.toastr.success('Shipping Cost updated successfully.', 'Success');
        } else {
          this.toastr.success('Shipping Cost saved successfully.', 'Success');
        }
        this.GetShippingCostList();
        // Intialize with new object
        let btnReset: HTMLElement = document.getElementById('btnReset') as HTMLElement;
        btnReset.click();
        //this.IntializeValues();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shipping-components/add-shipping-cost/add-shipping-cost.component.ts